import React, { useState } from "react";
import { Button } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setScore } from "../../features/scoreCounter/scoreSlice";

const QuizButton = ({ children }) => {
  const [buttonState, setButtonState] = useState(false);
  const [bgColor, setBgColor] = useState("#1f7ec1");
  const [border, setBorder] = useState("#ffffff");
  const { score } = useSelector((state) => state.score);
  const dispatch = useDispatch();

  const handleClick = () => {
    let currentScore = score;

    if (buttonState === false) {
      setButtonState(true);
      setBgColor("#06bcee");
      setBorder("#06bcee");
      let newScore = currentScore + 1;
      dispatch(setScore(newScore));
      console.log(newScore);
    } else {
      setButtonState(false);
      setBgColor("#1f7ec1");
      setBorder("#ffffff");
      let newScore = currentScore - 1;
      dispatch(setScore(newScore));
      console.log(newScore);
    }
  };

  return (
    <Button
      sx={{
        margin: ".5rem",
        width: "9rem",
        height: "9rem",
        backgroundColor: bgColor,
        borderRadius: "1rem",
        color: "#ffffff",
        fontSize: "0.7rem",
        fontWeight: "600",
        border: `solid 2px ${border}`,
        textAlign: "left",
        "&:hover": {
          backgroundColor: bgColor,
        },
      }}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};

export default QuizButton;
